import { ReactElement } from "react";
import { HubSidebarItemContent } from "./HubSidebarItemContent";
import { HubDataSource } from "client/Api/Hub/hub";
import { FontIconName, ReorderableList, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { hubDataSourceToLocalizationKeyMap } from "./HubItemNode";
import { generateTrackingId } from "client/Misc/utils";

export type HubSidebarRootItemProps = {
	source: HubDataSource;
};

export const HubSidebarRootItem = (props: HubSidebarRootItemProps): ReactElement => {
	const { source } = props;

	return (
		<ReorderableList.RowItem
			trackingId={generateTrackingId("hub-sidebar-item", `|${source}`)}
		>
			<HubSidebarItemContent
				trackingId="content"
				icon={{
					kind: "font",
					name: hubDataSourceToIcon[source],
					color: "primary"
				}}
			>
				<Typography weight="bold">
					{localize(hubDataSourceToLocalizationKeyMap[source])}
				</Typography>
			</HubSidebarItemContent>
		</ReorderableList.RowItem>
	);
};
HubSidebarRootItem.displayName = "HubSidebarRootItem";

export const hubDataSourceToIcon: {[key in HubDataSource]: FontIconName} = {
	[HubDataSource.Announcement]: "bullhorn",
	[HubDataSource.Community]: "users",
	[HubDataSource.Event]: "calendar-star",
	[HubDataSource.KnowledgeItem]: "book"
};